import React, { useState, useEffect , useRef, useContext} from 'react'
import FileListing from '../Storage/FileListing'
import FileUpload from '../Storage/FileUpload'
import { Navigate } from 'react-router-dom'
import axios from 'axios'
import { Button, Modal } from 'react-bootstrap'
import {Row,Col} from 'react-bootstrap'
import DocumentViewer from '../Storage/DocumentViewer'
import { AppContext } from '../../context/AppContext'


const DocumentManagement = ({sID, context}) => {

    const {SiteConfig, token} = useContext(AppContext);
    const dataFetchedRef = useRef(false);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const[showUploadPanel, setShowUploadPanel] = useState(false);
    
    const [selectedFile, setSelectedFile] = useState(null);
    const [isFilePicked, setIsFilePicked] = useState(false);     
    const [msg, setMsg] = useState(null);
    const [bshow, setbshow] = useState(false);
    const [bshowObj, setbshowObj] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);
  
    
    useEffect(()=>{
  
  
      if (dataFetchedRef.current) return;
      dataFetchedRef.current = true;
  
      const headers = {
            'Authorization': 'Bearer '+ token //localStorage.getItem(SiteConfig.API_AUTH_TOKEN)      
          };
  
        const URL = SiteConfig.API_BASE_URL + "Storage/Get/?context="+ context +"&ID="+ sID;
        // ApiGetData(URL,setData, setError);
  
         axios.get(URL,{headers})        
            .then((Response)=>{
                setData(Response.data);
                
            }).catch(error => {
                setError(error);     
                //console.log({error})                
            });
  
    },[msg]);
  
    
  
  
  
    const handleShowUploadPanel = ()=>{
      setMsg("");
      setIsFilePicked(false);
      setShowUploadPanel(true)
    }
  
    
      const handlechange = (e)=>{
    
        setSelectedFile(e.target.files[0]);
  
        //selectedFile.name = "dasda" + selectedFile.name;
        // let currFile = e.target.files[0];
        // let filename = "abcd" + currFile.name;
        // currFile.name = filename;
        // setSelectedFile(currFile)
        setIsFilePicked(true);
    
    
        //alert(selectedFile.name);
        //console.log(selectedFile);
        return null
      }  
  
  
      function detailSelect(obj){
  
  
        setbshowObj(obj);
        //console.log(obj);
        
        setbshow(true);
    
      }  
  
  function closeModal(){
    setbshow(false);
  }
  
  
  function openDeleteModal(){  
    setDeleteModal(true);
  }
  
  function closeDeleteModal(){
    setDeleteModal(false);
    
  }
  
  function handleDeleteEvent(){
    
  
    const sURL = SiteConfig.API_BASE_URL + "Storage/"+bshowObj.name+"/?context="+ context +"&ID="+sID;
  
    const headers = {    
      'Authorization': 'Bearer '+ token //localStorage.getItem(SiteConfig.API_AUTH_TOKEN)      
    };
  
  
      axios.delete(sURL,{headers})
      .then((Response)=>{        
          //console.log(Response.data)
         let res = Response.data
         setMsg(res);       
         dataFetchedRef.current = false;
         closeDeleteModal();
         setbshow(false);
  
      }).catch(error => {
          setError(error);     
          //console.log({error})
      });
  
  }
  
    
    const handleUpload = () => {
    
        const frmFormData = new FormData();
        frmFormData.append('File', selectedFile);
          
        const sURL = SiteConfig.API_BASE_URL + "Storage/Upload/?context="+ context +"&ID="+sID;
  
        const headers = {
          'Content-Type': selectedFile.type,
          'Authorization': 'Bearer '+ token //localStorage.getItem(SiteConfig.API_AUTH_TOKEN)      
        };
  
    
          axios.post(sURL,frmFormData,{headers})
          .then((Response)=>{
              //setClients(Response.data);
              console.log(Response.data)
             let res = Response.data
             setMsg(res.status);
             setSelectedFile(null);
             setShowUploadPanel(false);
             dataFetchedRef.current = false;
          }).catch(error => {
              setError(error);     
              //console.log({error})
          });
    
      //alert('sss');
    
    };
  
   
  
    if (error) 
    {      
      if(error.message.indexOf("status code 401")){
        return <Navigate to="/auths/auth-login" />
      } else
      return "Error: ${error.message}";
    }
  
    return (
      <> 
        <Button variant="outline-primary" style={{marginLeft:"22px"}} onClick={handleShowUploadPanel}>+ New Document</Button>    
        {showUploadPanel && <FileUpload handleUpload={handleUpload} handlechange={handlechange} isFilePicked={isFilePicked} msg={msg}/> }
        {data && <FileListing data={data} detailSelect={detailSelect} />}
  
        {bshowObj && 
        <Modal show={bshow} onHide={closeModal} size="xl" backdrop="static" fullscreen="sm-down" >
          <Modal.Header closeButton>
            <Modal.Title className="event-title" as="h4">{bshowObj.name}</Modal.Title>  
          </Modal.Header>
          <Modal.Body>
            <div>
              <Row>       
                  <Col>         
                    <>
                    <DocumentViewer docobj={bshowObj} />
                    </>                     
                  </Col>        
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
        
                  {SiteConfig.CURRENT_USER_ROLE == "admin" && 
                  <>
                  <Button variant="danger" onClick={openDeleteModal}>Delete</Button>      
                  </>
                  }
          </Modal.Footer>
        </Modal>
  }
  
  
    <Modal show={deleteModal} onHide={closeDeleteModal} backdrop="static">
          <div className="modal-content">
              <div className="modal-body p-5 text-center">
                  <div className="media media-rounded media-xxl media-middle mx-auto text-bg-danger mb-4"><em className="icon ni ni-cross"></em></div>
                  <h3>Are You Sure ?</h3>
                  <p className="small">This data will be removed permanently.</p>
                  <ul className="d-flex gap g-3 justify-content-center pt-1">
                      <li><Button variant="success" onClick={handleDeleteEvent}>Yes Delete it!</Button></li>
                      <li><Button variant="danger" className="btn-soft" onClick={closeDeleteModal}>Cancel</Button></li>
                  </ul>
              </div>
              <button type="button" className="btn-close position-absolute top-0 end-0 p-3" onClick={closeDeleteModal} aria-label="Close"></button>
          </div>
    </Modal>
  
      </>
    )
  }


export default DocumentManagement